// FORMFIELDS (2/2) v1.6
/* Change History:
    V1.8 InitConditial and ValidateConditionalChecksAndRadios moved to scripts.conditional.js
    V1.7 added (optional) container element to init formfields after ajax updating
    V1.6 added SaveActiveElement/RestoreActiveElement
	V1.5 checkFilled function added to avoid trigger(blur)
	v1.4 Placeholder behaviour and polyfill
	v1.3 Trigger blur on load
	v1.2 Excluding hidden inputs
	v1.1 isChrome function outside each-loop
	v1.0 Formfields within function
*/
var FormFields = {
	ActiveID: null,
	ActiveTab: null
};

FormFields.Init = function(container) {
	
	FormFields.InitInputs(container);
	
	FormFields.InitChecksAndRadios(container);
	
	// INPUT FILLED CHROME
	if ($('html').hasClass('chrome')) {
		$('input:-webkit-autofill', container).parents('div.field').addClass('filled');
	}
	
	// DISABLED (v1.1)
	$('.disabled, .disabled *', container).click(function (event) {
		event.preventDefault();
	});

	// ADD CLASS HAS_SELECT ON EACH PARENT OF A SELECTFIELD
	$('select', container).each(function(){
		$(this).parent().addClass('has_select');
	});

	// HINT CLICKING (tablet support) v1.0
	$('div.field label', container).not('.disabled label').click(function () {
		$(this).siblings('input,textarea').focus();
	});	
};


// RADIOS and CHECKS - label fix for iPad, radioList for eg. paymentOptions (v1.1)
FormFields.InitChecksAndRadios = function(container) {

	$('.radios label, .checks label, ol.radioList > li, ul.radioList > li', container).not(':has(input:disabled)').click(function (event) {
		if ($(event.target).is(":not('a, input, label')")) {
			$('input:radio', this).attr('checked', 'checked');
			$('input:radio', this).trigger('click');
		}

		$(this).addClass('active').siblings().removeClass('active');
	}).each(function () {
		$(this).filter(':has(input[type="radio"]:checked)').addClass('active').siblings().removeClass('active');
	});
};

FormFields.InitInputs = function(container) {

	// Check for placeholder support (depends on placeholder detection)
	var browserSupportsPlaceHolder = $('html').hasClass('placeholder');
	
	$('input.text, textarea, select', container).not('input[type=hidden]').each(function () {

		// HTML5 PLACEHOLDER polyfill, ! only use when top positioned labels on .field.focus aren't used and labels arent added by default! */
		// if ( $(this).attr('placeholder') ) {
		// 	var placeholderText = $(this).attr('placeholder');
		// 	var placeholderId = $(this).attr('id');

		// 	if (browserSupportsPlaceHolder) {
		// 	 	following  script also hides label when positioned above field on .focus.filled
		// 		$(this).prev('label[for="'+ placeholderId +'"]').hide(); 
		// 	} else {
		// 		following script should only be applied if labels above fields are not used, because then the labels should not be added in html by default 
		// 	 	$(this).before('<label for="'+ placeholderId +'">' + placeholderText + '<\/label>');
		// 	}
		// }

		// INPUT FOCUS
		$(this).not('[readonly]').focus(function () {

			$(this).select().parent().addClass('focus');
			$(this).closest('.fieldWrap').addClass('focus').find('.label').addClass('focus');

			if( $(this).parents('.ios').length ) {
				$('#wrapper').addClass('iosFocus');
			}
		});

		// INPUT LOAD
		FormFields.CheckFilled(this);

		// INPUT BLUR
		$(this).blur(function () {
			FormFields.CheckFilled(this);
		});

		// INPUT FILLED KEYUP
		$(this).keyup(function () {
			if ($(this).val() != "") {
				$(this).parent().addClass('filled');
			}
		});
	});
};

// CHECK FOR FILLED INPUTS
FormFields.CheckFilled = function(obj) {

	$(obj).parent().removeClass('focus');
	$(obj).closest('.fieldWrap').removeClass('focus').find('.label').removeClass('focus');

	if ($(obj).val() != "") {
		$(obj).parent().addClass('filled');
		//$(obj).closest('.fieldWrap').find('.label').addClass('filled');
	} else {
		$(obj).parent().removeClass('filled');
		//$(obj).closest('.fieldWrap').find('.label').removeClass('filled');
	};
	if( $(obj).parents('.ios').length ) {
		$('#wrapper').removeClass('iosFocus');
	}
};

//CALL BEFORE UPDATING HTML WITH AJAX
FormFields.SaveActiveElement = function(){
    var activeElement = $(document.activeElement);
    if (activeElement){
        FormFields.ActiveTab = activeElement.attr('tabindex');
        FormFields.ActiveID = activeElement.attr('id');
        
        if (FormFields.ActiveTab == '') {
            FormFields.ActiveTab = null;
        }
    } else {
        FormFields.ActiveID = null;
        FormFields.ActiveTab = null;
    }
};

//CALL AFTER UPDATING HTML WITH AJAX
FormFields.RestoreActiveElement = function(){
    if (FormFields.ActiveID){
        var activeElement;
        
        if (FormFields.ActiveTab){
            activeElement = $('[tabindex=' + FormFields.ActiveTab + ']');
        }
        else {
            activeElement = $('#'+ FormFields.ActiveID);
        }
        
        if (activeElement){
            activeElement.focus();
        }  
        
        FormFields.ActiveID = null;
        FormFields.ActiveTab = null;
    }
};